/* RESPONSIBLE TEAM: team-ml */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type AppService from 'embercom/services/app-service';
import type RouterService from '@ember/routing/router-service';

export default class WorkforceRoute extends Route {
  @service declare appService: AppService;
  @service declare router: RouterService;

  beforeModel() {
    if (!this.appService.app.canUseFeature('wfm-v0')) {
      this.router.transitionTo('apps.app');
    }
  }
}
